<template>
  <div class="liu">
    <mt-header fixed title="流量费设置" class="title1">
      <mt-button slot="left" icon="back" @click="onBackClick">返回</mt-button>
      <mt-button slot="right" v-if="isHasFee" @click="onMyFlowCostClick">我的流量费</mt-button>
    </mt-header>
    <div class="scroll-container" :style="customScrollHeight" v-infinite-scroll="getMoreMyData" :infinite-scroll-disabled="myData.scrollDisabled" infinite-scroll-distance="0">
      <!-- 提示行 -->
      <!-- 如果有tips提示信息，此div样式要用class="tips-box" -->
      <div />
      <!-- 空页 -->
      <div v-if="isEmptyData"></div>
      <!-- 列表 -->
      <div>
        <div class="agent-push-box" v-for="(item, index) in myData.list" :key="index" @click="onMyAgentFlowCostClick(item.productAgentId,item.name,item.smsYearFeeSplitMoney,item.minSmsYearFeeSplitMoney,item.maxSmsYearFeeSplitMoney)">
          <div class="agent-push link center">
            <span class="fee-info-box">{{ `${item.name}(${String(item.mobile).substr(-4)})` }}</span>
            <span class="fee-info-box">{{ item.smsYearFeeSplitMoney | num }}</span>
          </div>
        </div>
      </div>
      <!-- 无数据占位图 -->
      <div v-if="isNoData">
        <div class="no-data">
          <img src="../../assets/bitmap_datafee@3x.png" width="60%" />
          <div class="title-5">暂无相关数据</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
/* global PUBLIC_PRODUCT */

import { Indicator } from 'mint-ui';
import { CusToast } from '@/utils/CustomToast';
import { SucceedHandle2, NotSucceedHandle } from '@/api/handle';
import { GetUserFlowRateFee, GetUserFlowRateFeeList } from '@/api/agent';

export default {
  name: 'FlowCostList',
  data() {
    return {
      product: PUBLIC_PRODUCT.toLowerCase().trim(),
      // 列表信息
      myData: {
        list: [],
        total: -1,
        fee: null,
        scrollDisabled: true,
      },
      // 查询参数
      myParam: {
        pageNum: 1,
        pageSize: 11,
      },
    };
  },
  mounted() {
    this.initData();
  },
  computed: {
    customScrollHeight() {
      return `height:${window.innerHeight}px;`;
    },
    isEmptyData() {
      return this.myData.total === -1;
    },
    isHasData() {
      return this.myData.total > 0;
    },
    isNoData() {
      return this.myData.total === 0;
    },
    isHasFee() {
      return this.myData.fee || String(this.myData.fee) === '0';
    },
    currentHelpText() {
      return this.helpText.filter(item => item.product.indexOf(this.product) > -1);
    },
  },
  methods: {
    // 加载数据
    initData() {
      // 滚动条置顶
      window.scrollTo(0, 0);
      // 列表清空
      this.myData.list = [];
      // 加载数据
      this.getMyData();
    },
    // 通过接口获取数据
    getMyData() {
      Indicator.open();
      // 先设置禁止滚动加载数据
      this.myData.scrollDisabled = true;
      // 获取当前代理商流量费
      GetUserFlowRateFee()
        .then(res => {
          this.myData.total = res.total;
          // 获取并设置当前代理商流量费，没有则为null
          this.myData.fee = res.data.smsYearFeeSplitMoney || null;
          // 判断流量费是否为null，如果不为null则证明当前代理商有流量费
          // 有流量费的情况下获取当前代理商下级代理商的流量费列表
          // 反之，流量费为null，则啥也不做
          if (!this.isNoFee) {
            // 获取下级代理商流量费列表
            GetUserFlowRateFeeList(this.myParam)
              .then(res => {
                Indicator.close();
                SucceedHandle2(
                  res.code,
                  res.msg,
                  () => {
                    this.myData.total = res.total;
                    this.myData.list.push(...res.rows);
                    // 通过记录条数list.length和数据总数total判断是否查询出所有数据
                    // 如果记录条数小于数据总数，则证明没有查询出所有数据，设置允许滚动加载数据
                    if (this.myData.list.length < this.myData.total) {
                      this.myData.scrollDisabled = false;
                    }
                  },
                  (code, msg) => {
                    msg && CusToast(msg);
                  }
                );
              })
              .catch(err => {
                Indicator.close();
                this.myData.list = [];
                this.myData.total = -1;
                this.myData.scrollDisabled = true;
                this.myParam.pageNum = 1;
                const msg = NotSucceedHandle(err.message);
                msg && CusToast(msg);
              });
          } else {
            Indicator.close();
          }
        })
        .catch(err => {
          Indicator.close();
          this.myData.total = -1;
          const msg = NotSucceedHandle(err.message);
          msg && CusToast(msg);
        });
    },
    // 自动加载获取更多数据
    getMoreMyData() {
      // 通过记录条数list.length和数据总数total判断是否查询出所有数据
      // 如果记录条数小于数据总数，则证明没有查询出所有数据，让页数加1并继续获取数据
      if (this.myData.list.length < this.myData.total) {
        this.myParam.pageNum += 1;
        this.getMyData();
      }
    },

    // 返回按钮点击事件
    onBackClick() {
      window.location.href = 'protocol://android';
    },
    // 我的流量费点击事件
    onMyFlowCostClick() {
      this.toFlowCostEditPage('1', null, null, null, this.formatFee(String(this.myData.fee)));
    },
    // 我的代理商流量费点击事件
    onMyAgentFlowCostClick(productagentid, name, fee, min, max) {
      const placeholder = `${this.formatFee(String(min))} - ${this.formatFee(String(max))}`;
      this.toFlowCostEditPage('2', productagentid, name, placeholder, this.formatFee(String(fee)));
    },
    // 跳转编辑页面
    toFlowCostEditPage(type, id, name, placeholder, fee) {
      this.$router.push({
        path: '/flowcostedit',
        query: { type, id, name, placeholder, fee },
      });
    },
    // 格式化
    formatFee(fee) {
      if (!fee) return null;
      if (fee === 'undefined') return null;
      if (fee === '0') return fee;
      if (fee.length === 1) return `0.0${fee}`;
      if (fee.length === 2) return `0.${fee}`;
      if (fee.length > 2) return `${fee.substring(0, fee.length - 2)}.${fee.substr(-2)}`;
    },
  },
  filters: {
    num(val) {
      if (!val) return '0.00';
      if (String(val) === 'undefined') return '0.00';
      if (String(val) === '0') return '0.00';
      if (String(val).length === 1) return `0.0${val}`;
      if (String(val).length === 2) return `0.${val}`;
      if (String(val).length > 2) {
        return `${String(val).substring(0, String(val).length - 2)}.${String(val).substr(-2)}`;
      }
    },
  },
};
</script>
